import React from "react";
import * as XLSX from "xlsx-js-style";
import { formatDateTime } from "../../../../../../utils/dateFormat";

const camelToNormal = (text) =>
  text
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (s) => s.toUpperCase());

export default function ExportCSV({ data }) {
  const exportCSV = () => {
    const formatted = data.map((item) => ({
      searchedName:
        item.searched_first_name ||
        item.searched_middle_name ||
        item.searched_last_name ||
        item.searched_alias
          ? `${item.searched_first_name || ""} ${
              item.searched_middle_name || ""
            } ${item.searched_last_name || ""} ${
              item.searched_alias || ""
            }`.trim()
          : item.searched_company || "",
      searcher: `${item.searcher.firstName} ${
        item.searcher.middleName || ""
      } ${item.searcher.lastName}`,
      date: formatDateTime(item.createdAt),
      client: item.searcher?.affiliate?._id,
      branch: item.searcher?.branch?.code || item.searcher?.branch?._id,
    }));

    if (formatted.length === 0) return;

    const headers = Object.keys(formatted[0]).map(camelToNormal);
    const wsData = [headers, [], ...formatted.map((row) => Object.values(row))];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    headers.forEach((_, idx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: idx });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true },
          alignment: { horizontal: "center" },
        };
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");
    XLSX.writeFile(wb, "search_logs_export.xlsx");
  };

  return (
    <button className="btn btn-secondary" onClick={exportCSV}>
      Export CSV
    </button>
  );
}
